var RequestStatusTypes;
(function (RequestStatusTypes) {
  RequestStatusTypes["UNINITIALIZED"] = "UNINITIALIZED";
  RequestStatusTypes["PENDING"] = "PENDING";
  RequestStatusTypes["SUCCEEDED"] = "SUCCEEDED";
  RequestStatusTypes["FAILED"] = "FAILED";
})(RequestStatusTypes || (RequestStatusTypes = {}));
export default RequestStatusTypes;